import React, { useMemo } from 'react';

import Button from 'components/shared/Button';
import Modal from 'components/shared/Modal';

import type { ModalProps } from 'components/shared/Modal/Modal';

export type AlertProps = Pick<ModalProps, 'title' | 'labelledBy' | 'lastFocusedElementId'> & {
  onClose: () => void;
  message?: string;
  messageHTML?: JSX.Element | JSX.Element[] | null;
  showPreventDialog?: boolean;
  onPreventDialog?: React.ChangeEventHandler<HTMLInputElement>;
  onContinue: React.MouseEventHandler;
  onCancel: React.MouseEventHandler;
};

function Alert({
  title,
  labelledBy,
  lastFocusedElementId,
  onClose,
  message = '',
  messageHTML = null,
  showPreventDialog = false,
  onPreventDialog = () => {},
  onContinue,
  onCancel,
}: AlertProps) {
  const alertMessage = messageHTML ? (
    <div className="alert-message">{messageHTML}</div>
  ) : (
    <p className="alert-message">{message}</p>
  );

  const alertButtons = (
    <React.Fragment>
      <Button type="confirm" onClick={onContinue}>
        Continue
      </Button>
      <Button type="cancel" onClick={onCancel}>
        Cancel
      </Button>
    </React.Fragment>
  );

  const preventDialogMessage = useMemo(() => {
    if (showPreventDialog)
      return (
        <div>
          <input id="prevent-dialog" type="checkbox" onChange={onPreventDialog} />
          <label htmlFor="prevent-dialog">Don&apos;t show this again</label>
        </div>
      );

    return null;
  }, [showPreventDialog, onPreventDialog]);

  return (
    <Modal
      isAlert
      title={title}
      labelledBy={labelledBy}
      lastFocusedElementId={lastFocusedElementId}
      onClose={onClose}
      primaryFooterGroup={alertButtons}
    >
      {alertMessage}
      {preventDialogMessage!}
    </Modal>
  );
}

export default Alert;
